/**
 * useWorkOrderStatusList Hook
 *
 * React Query hook for fetching work order status options for the work orders filter.
 */

import { queryKeys } from '@/lib/query-client';
import { useQuery } from '@tanstack/react-query';
import { getWorkOrderStatusList } from '../api/workOrderStatusApi';

/**
 * Fetch work order statuses for the work orders status filter dropdown
 */
export function useWorkOrderStatusList() {
  const queryKey = queryKeys.jobs.workOrderStatuses();

  const query = useQuery({
    queryKey,
    queryFn: () => getWorkOrderStatusList(),
    staleTime: 5 * 60 * 1000, // 5 minutes - statuses don't change often
    gcTime: 30 * 60 * 1000, // 30 minutes
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isPending: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
    status: query.status,
  };
}
